/**
 * Sticky buy bar (docs/03 "Sticky mobile buy bar", product.md item 19).
 * Shows once the add button has scrolled above the viewport, hides again when
 * the button or the footer is in view. The bar's button submits the main
 * product form, so product-form.js handles the add. On variant change the
 * price and button are copied from the re-rendered section.
 */
if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        // The quick-add modal copies the whole section; its bar stays inert.
        if (this.closest('quick-add-modal')) return;
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;
        this.footer = document.querySelector('.shopify-section-group-footer-group, footer');
        this.mql = window.matchMedia('(max-width: 749px)');
        this.buttonAbove = false;
        this.footerVisible = false;

        this.buttonObserver = new IntersectionObserver(([entry]) => {
          this.buttonAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.update();
        });
        this.buttonObserver.observe(this.target);

        if (this.footer) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.footerVisible = entry.isIntersecting;
            this.update();
          });
          this.footerObserver.observe(this.footer);
        }

        this.mql.addEventListener('change', () => this.update());

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.onVariantChange(data));
        }
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.footerObserver?.disconnect();
        this.unsubscribe?.();
        document.documentElement.classList.remove('has-sticky-bar');
      }

      update() {
        const visible = this.mql.matches && this.buttonAbove && !this.footerVisible;
        this.classList.toggle('is-visible', visible);
        // Keep focused elements clear of the bar (WCAG 2.4.11).
        document.documentElement.classList.toggle('has-sticky-bar', visible);
      }

      // No variant matches the chosen options: product-info.js calls this
      // instead of publishing a variant change.
      setUnavailable() {
        const button = this.querySelector('button');
        if (!button) return;
        button.setAttribute('disabled', '');
        button.textContent = window.variantStrings?.unavailable || '';
      }

      onVariantChange({ html, sectionId }) {
        if (!html || sectionId !== this.dataset.section) return;
        const rendered = html.querySelector('product-info');
        if (rendered && rendered.dataset.productId !== this.dataset.productId) return;

        const price = html.getElementById(`StickyPrice-${sectionId}`);
        const priceTarget = this.querySelector(`#StickyPrice-${sectionId}`);
        if (price && priceTarget) priceTarget.innerHTML = price.innerHTML;

        const button = html.getElementById(`StickySubmit-${sectionId}`);
        const buttonTarget = this.querySelector(`#StickySubmit-${sectionId}`);
        if (button && buttonTarget) {
          buttonTarget.toggleAttribute('disabled', button.hasAttribute('disabled'));
          buttonTarget.textContent = button.textContent.trim();
        }
      }
    }
  );
}
